import update from 'immutability-helper';
import {
  AUTHENTICATION_SUCCESSFUL,
  CREATE_ACCOUNT,
  DESKTOP_GOOGLE_AUTH,
  EMAIL_LOGIN,
  LOGOUT,
  OAUTH_LOGIN,
  RECEIVE_NEW_AUTH,
  UNAUTHENTICATE,
  UPDATE_FB_SDK_STATUS,
  UPDATE_GOOGLE_SDK_STATUS,
  VERIFY_DEVICE_PIN,
} from '../actions/auth';
import { oAuthSdkStates } from '../constants/auth/oauth';
import createMappedReducer from './utils/createMappedReducer';
import { fulfilled, pending, rejected } from './utils/asyncActionNameSuffixes';

const initialState = {
  googleAuthSdkStatus: oAuthSdkStates.loading,
  fbAuthSdkStatus: oAuthSdkStates.loading,
  tokenInfo: {},
};

function authPartiallyFulfilled(state, action) {
  return update(state, {
    $merge: {
      pending: {
        tokenInfo: action.payload.tokenData,
      },
    },
  });
}

function authFulfilled(state, action) {
  return update(state, {
    tokenInfo: {
      $set: state.pending?.tokenInfo || action.payload.tokenData,
    },
    $unset: ['pending'],
  });
}

function unauthFulfilled() {
  return initialState;
}

function handleNewAuth(state, action) {
  return update(state, { tokenInfo: { $set: action.tokenData } });
}

function updateGoogleAuthSdkStatus(state, action) {
  return update(state, {
    googleAuthSdkStatus: { $set: action.status },
  });
}

function updateFbAuthSdkStatus(state, action) {
  return update(state, {
    fbAuthSdkStatus: { $set: action.status },
  });
}

function devicePinPending(state) {
  return update(state, {
    isFetching: { $set: true },
  });
}

function devicePinRejected(state, action) {
  return update(state, {
    isFetching: { $set: false },
    [action?.meta?.contentId]: { $set: { hasFailed: true } },
  });
}

function devicePinFulfilled(state, action) {
  return update(state, {
    isFetching: { $set: false },
    [action?.meta?.contentId]: { $set: action?.payload?.data },
  });
}

export const auth = createMappedReducer(initialState, {
  [fulfilled(EMAIL_LOGIN)]: authPartiallyFulfilled,
  [fulfilled(OAUTH_LOGIN)]: authPartiallyFulfilled,
  [fulfilled(CREATE_ACCOUNT)]: authPartiallyFulfilled,
  [pending(VERIFY_DEVICE_PIN)]: devicePinPending,
  [rejected(VERIFY_DEVICE_PIN)]: devicePinRejected,
  [fulfilled(VERIFY_DEVICE_PIN)]: devicePinFulfilled,
  [fulfilled(LOGOUT)]: unauthFulfilled,
  [AUTHENTICATION_SUCCESSFUL]: authFulfilled,
  [fulfilled(DESKTOP_GOOGLE_AUTH)]: authFulfilled,
  [UPDATE_GOOGLE_SDK_STATUS]: updateGoogleAuthSdkStatus,
  [UPDATE_FB_SDK_STATUS]: updateFbAuthSdkStatus,
  [RECEIVE_NEW_AUTH]: handleNewAuth,
  [UNAUTHENTICATE]: unauthFulfilled,
});
